import React from "react";
import { cn } from "../../../lib/utils";
import { useConfiguratorContext } from "../../../hooks/configurator/configurator-context";
import { SelectionIndicator } from "./SelectionIndicator";
import { OptionInfo } from "./OptionInfo";
import { OptionThumbnail } from "./OptionThumbnail";
import { OptionPrice } from "./OptionPrice";
import { ConflictIndicator } from "./ConflictIndicator";

interface RowDisplayProps {
  options: any[];
  section: any;
}

export const RowDisplay: React.FC<RowDisplayProps> = ({ options, section }) => {
  const configurator = useConfiguratorContext();
  return (
    <div className="flex flex-col space-y-4">
      {options.map((option) => (
        <div
          key={option.id}
          className={cn(
            "border overflow-hidden flex cursor-pointer transition-all duration-300 group hover:shadow-sm",
            configurator.isOptionSelected(option.id)
              ? "border-black bg-black text-white shadow-sm"
              : "border-gray-200 hover:border-black/20 bg-white text-black",
            !configurator.canSelectOption(section.id, option.id) &&
              "opacity-50 relative"
          )}
          title={
            !configurator.canSelectOption(section.id, option.id)
              ? "Selecting this option will replace incompatible selections"
              : ""
          }
          onClick={() => configurator.toggleOption(section.id, option.id)}
        >
          <div className="shrink-0 w-32 h-[84px] relative border-r border-gray-200 bg-gray-50 group-hover:bg-gray-100 transition-colors duration-300">
            <OptionThumbnail
              option={option}
              width={128}
              height={84}
              className="w-full h-full object-cover"
            />
            <OptionInfo option={option} />
            <ConflictIndicator
              hasConflict={!configurator.canSelectOption(section.id, option.id)}
              position="top-right"
            />
          </div>
          <div className="grow p-6 flex items-center">
            <div className="grow">
              <h3 className="text-base" style={{ fontWeight: "300" }}>
                {option.label}
              </h3>
              {option?.metadata?.uiDescription && (
                <p
                  className={cn(
                    "text-sm mt-2 leading-relaxed",
                    configurator.isOptionSelected(option.id)
                      ? "text-gray-300"
                      : "text-gray-600"
                  )}
                >
                  {option.metadata.uiDescription}
                </p>
              )}
              <OptionPrice
                price={option.price}
                isSelected={configurator.isOptionSelected(option.id)}
                className="mt-2"
              />
            </div>
            <div className="shrink-0 ml-4">
              <SelectionIndicator
                isSelected={configurator.isOptionSelected(option.id)}
                isMultiple={section?.multiple}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
